import HeaderComponent from '../../components/shared/Header/HeaderManagerComponent';
import CookieConsent from '../shared/CookieConsent/CookieConsent';
import dynamic from 'next/dynamic';
const MobileBottomNav = dynamic(() => import('../shared/Mobile/MobileBottomNav'), { ssr: false });
const FooterComponent = dynamic(() => import('../../components/shared/Footer/FooterComponent'), { ssr: false });

export default function DefaultLayout({ children }) {
  // decide here for app layout?
  return (
    <>
      <HeaderComponent />
      <main>{children}</main>
      <FooterComponent />
      <MobileBottomNav />
      <CookieConsent></CookieConsent>
    </>
  );
}
